import { compose, withState, withHandlers } from 'recompose';
import PromoTidalCheckout from '../components/PromoTidalCheckout';

export default compose(
  withState('isExpanded', 'setIsExpanded', false),

  withHandlers({
    expand: props => () => {
      props.setIsExpanded(true);
    },
  }),
)(PromoTidalCheckout);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/PromoTidalCheckout.jsx